// SupportedChainId must be defined inline, without using @x-swap-protocol/sdk-core, so that its members are their own types
// {@see https://www.typescriptlang.org/docs/handbook/enums.html#union-enums-and-enum-member-types}. This allows the
// derived const arrays and their types (eg {@link L1_CHAIN_IDS}, {@link SupportedL1ChainId}) to be narrowed and used
// to enforce chain typing.
//
// Because this is not explicitly derived from @x-swap-protocol/sdk-core, there is a unit test to enforce conformance.
export enum SupportedChainId {
  XDC = 50,
  XDC_TESTNET = 51,
}

export const CHAIN_IDS_TO_NAMES = {
  [SupportedChainId.XDC]: 'xifin',
  [SupportedChainId.XDC_TESTNET]: 'apothem',
}

/**
 * Array of all the supported chain IDs
 */
export const ALL_SUPPORTED_CHAIN_IDS: SupportedChainId[] = Object.values(SupportedChainId).filter(
  (id) => typeof id === 'number'
) as SupportedChainId[]

export function isSupportedChain(chainId: number | null | undefined): chainId is SupportedChainId {
  return !!chainId && (chainId === SupportedChainId.XDC || chainId === SupportedChainId.XDC_TESTNET)
}

export const SUPPORTED_GAS_ESTIMATE_CHAIN_IDS = [SupportedChainId.XDC] as const

/**
 * Unsupported networks for V2 pool behavior.
 */
export const UNSUPPORTED_V2POOL_CHAIN_IDS = [] as const

export const TESTNET_CHAIN_IDS = [SupportedChainId.XDC_TESTNET] as const

export type SupportedTestnetChainId = (typeof TESTNET_CHAIN_IDS)[number]

/**
 * All the chain IDs that are running the Ethereum protocol.
 */
export const L1_CHAIN_IDS = [SupportedChainId.XDC, SupportedChainId.XDC_TESTNET] as const

export type SupportedL1ChainId = (typeof L1_CHAIN_IDS)[number]

/**
 * Controls some L2 specific behavior, e.g. slippage tolerance, special UI behavior.
 * The expectation is that all of these networks have immediate transaction confirmation.
 */
export const L2_CHAIN_IDS: any = [] as const

export type SupportedL2ChainId = (typeof L2_CHAIN_IDS)[number]
